import React, { Component } from 'react';
import PropTypes from 'prop-types';

const IsLoadingWrapper = WrappedComponent => {
  class IsLoading extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isLoading: true,
      };

      this.endLoading = this.endLoading.bind(this);
    }

    endLoading() {
      this.setState({
        isLoading: false,
      });
    }

    render() {
      const { isLoading } = this.state;

      return (
        <WrappedComponent isLoading={isLoading} endLoading={this.endLoading} {...this.props} />
      );
    }
  }

  IsLoading.propTypes = {
    children: PropTypes.node,
  };

  return IsLoading;
};

export default IsLoadingWrapper;
